/* eslint-disable */
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import './startPage.css';
import '../b2bPage/b2bPage.css';
import '../b2bPage/b2bGammaTheme.module.css';
import '../../components/buttons/mainBtn.css';
import { useNavigate, useOutletContext, useSearchParams } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import ErrorPage from '../errorPage/ErrorPage';
import { Row } from 'react-bootstrap';
import { StationMediaCarousel } from '../../components/stationMediaCarousel/StationMediaCarousel';
import { startCharging } from './startCharging';
import DelayedStartModal from './DelayedStartModal';
import DriverTermsAcceptToggle from './DriverTermsAcceptToggle';
import DriverTermsConfirmModal from './DriverTermsConfirmModal';
import RestartStationButton, { canShowRestartStation } from './RestartStationButton';
import StartPageEmsCarousel from './StartPageEmsCarousel';
import StartPageTopOnlineStatus from './StartPageTopOnlineStatus';
import StartPageStationNotes from './StartPageStationNotes';
import StartManyLocationHeader from '../startManyPage/StartManyLocationHeader';
import StartManyShareButton from '../startManyPage/StartManyShareButton';
import ChargingPortCard from './ChargingPortCard';
import Modal from '../../components/modal/Modal';
import {
  api,
  useGetBalanceQuery,
  useGetEcRemainingKwhQuery,
  useGetDeviceStatusQuery,
  useGetStationStatusQuery,
  useCreateReservationMutation,
  useCancelReservationMutation,
  useLazyGetReservationDailyLimitQuery,
} from '../../redux/api';
import { useDispatch } from 'react-redux';
import {
  isWorkingTime,
  plugTypeMaping,
  getPortInServiceMessage,
  getPortInRepairMessage,
  getStationOfflineMessage,
  isStationInService,
  isStationInRepair,
  isStationAllowReservation,
  getReservationMinutes,
  formatReservationCountdown,
  getPostJobBookCooldownSeconds,
  isReservationWhitelistClient,
  getReservationErrorCode,
} from '../../utils/utils';
import { stationDistanceKmFromUser } from '../../utils/stationDistanceKm';
import ModalContacts from '../contactsPage/modal/ModalContacts';
import ReactGA from 'react-ga';
import { LoadingSm } from '../../components/loaders/localLoading/LocalLoading';

import { useGetClientId, isNativeShellApp } from '../../hookServices/clientId';
import { useOpenEmsEvPortBatteryLimit } from '../../hookServices/useOpenEmsEvPortBatteryLimit';
import { getSocPriceTiersFromStation } from '../../utils/socDynamicPriceNotes';
import { useContactUsTelegramPreferred } from '../../hookServices/useContactUsTelegramPreferred';
import { TELEGRAM_BOT, isLocalSkipPaymentEnabled } from '../../environment';
import { isChargeCoveredWithoutCheckout } from './startPageZeroTariff';
import OpenMapsConfirmModal from '../../components/OpenMapsConfirmModal';
import OutageScheduleButton from '../../components/outageSchedule/OutageScheduleButton';
import LeaveFeedbackModal from './LeaveFeedbackModal';
import { paidPortsInHistory } from './paidSession';
import ServiceRequestModal from './ServiceRequestModal';
import { StationPublicReportsSection } from './StationPublicReports';
import RefundRequestModal from './RefundRequestModal';
import { isEnergyCardInvoiceId } from '../../hookServices/energyCard';

import { Button, Card, Slider, Icon, ActionButtonSpinner, getActionButtonLoadingClassName } from '@ui';
import buttonStyles from '../../shared/ui/button/button.module.css';
import Box from '@mui/material/Box';

/** True when the app runs as an installed PWA (not a normal browser tab). */
function isPwaStandaloneDisplay() {
  if (typeof window === 'undefined') return false;
  if (window.matchMedia('(display-mode: standalone)').matches) return true;
  if (typeof navigator !== 'undefined' && navigator.standalone === true) return true;
  return false;
}

/** Phones / tablets where "install app" messaging is relevant (excludes desktop-only tabs). */
function isLikelyMobileOrTabletUa() {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';
  if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua)) return true;
  if (/iPad/i.test(ua)) return true;
  if (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) return true;
  return false;
}

const START_PAGE_ACTION_BUTTON_STYLE = {
  borderRadius: '20px',
  minHeight: '56px',
};

export default function StartPage() {
  const { station, stationNumber, openFrom, closedFrom, isTwentyFourHour } = useOutletContext();
  const isInService = station?.name?.toLowerCase().includes('inservice');
  const isInRepair = isStationInRepair(station);
  const isFirstStartFree = station?.name?.toLowerCase().includes('firststartisfree');
  const isNativeApp = isNativeShellApp();
  /** Opt-in per station via firstStartIsFree name marker (admin checkbox). */
  const canOfferFreeStart = isFirstStartFree;
  const INITIAL_SLIDER_KWH = 20;
  const CUSTOM_CHARGE_MIN = 1;
  const CUSTOM_CHARGE_STEP = 1;
  const CUSTOM_CHARGE_MAX = 100;

  const costPerKwt = station?.costPerKwt;

  const [modalOpen, setModalOpen] = useState(false);
  const [kwt, setKwt] = useState(INITIAL_SLIDER_KWH);
  const [error, setError] = useState(null);
  const [startFreeStatus] = useState(false);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [customChargeValue, setCustomChargeValue] = useState(kwt);
  const [selectedPrice, setSelectedPrice] = useState(() => priceCalculate(customChargeValue));
  const [portStatus, setPortStatus] = useState({ isReady: false });
  const [portErrorOpen, setPortErrorOpen] = useState(false);
  const [isStarting, setIsStarting] = useState(false);
  const [temperature, setTemperature] = useState(null);
  const [quickStartLoading, setQuickStartLoading] = useState(false);
  const [freeChargeErrorOpen, setFreeChargeErrorOpen] = useState(false);
  const [rateLimitErrorOpen, setRateLimitErrorOpen] = useState(false);
  const [nativeAppFreeChargeOpen, setNativeAppFreeChargeOpen] = useState(false);
  const [reservationErrorOpen, setReservationErrorOpen] = useState(false);
  const [reservationErrorMessage, setReservationErrorMessage] = useState('');
  const [reservationConfirmOpen, setReservationConfirmOpen] = useState(false);
  const [guestPayConfirmOpen, setGuestPayConfirmOpen] = useState(false);
  const [countdownSeconds, setCountdownSeconds] = useState(null);
  const [termsAccepted, setTermsAccepted] = useState(() => localStorage.getItem('driverTermsAccepted') === 'true');
  const [termsConfirmOpen, setTermsConfirmOpen] = useState(false);
  const [mapsModalOpen, setMapsModalOpen] = useState(false);
  const [endSharePorts, setEndSharePorts] = useState([]);
  const handleSharePorts = useCallback(ports => {
    const next = Array.isArray(ports) ? ports : [];
    setEndSharePorts(prev => {
      if (prev.length === next.length && prev.every((port, index) => port === next[index])) {
        return prev;
      }
      return next;
    });
  }, []);
  const [feedbackModalOpen, setFeedbackModalOpen] = useState(false);
  const [serviceRequestModalOpen, setServiceRequestModalOpen] = useState(false);
  const [reportsReload, setReportsReload] = useState(0);
  const [refundModalOpen, setRefundModalOpen] = useState(false);
  const [refundSession, setRefundSession] = useState({ invoiceId: '', jobId: null });
  const [searchParams, setSearchParams] = useSearchParams();
  const pendingTermsActionRef = useRef(null);
  const reportStationNumbers = useMemo(
    () => (stationNumber != null && String(stationNumber).trim() !== '' ? [String(stationNumber)] : []),
    [stationNumber]
  );
  const bumpReports = useCallback(() => setReportsReload(value => value + 1), []);

  // Deep link from Telegram: /start?station=N&feedback=1 opens LeaveFeedbackModal.
  useEffect(() => {
    if (searchParams.get('feedback') !== '1') return undefined;
    setFeedbackModalOpen(true);
    ReactGA.event({
      category: 'feedback',
      action: 'open from url',
      label: String(stationNumber || searchParams.get('station') || ''),
    });
    const next = new URLSearchParams(searchParams);
    next.delete('feedback');
    setSearchParams(next, { replace: true });
    return undefined;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const refundDeepLinkPendingRef = useRef(searchParams.get('refund') === '1');

  useEffect(() => {
    if (termsAccepted) {
      localStorage.setItem('driverTermsAccepted', 'true');
    } else {
      localStorage.removeItem('driverTermsAccepted');
    }
  }, [termsAccepted]);

  const handleTermsAcceptedChange = checked => {
    setTermsAccepted(checked);
  };

  function handleTermsGatedAction(action) {
    if (termsAccepted) {
      action();
      return;
    }
    pendingTermsActionRef.current = action;
    setTermsConfirmOpen(true);
  }

  function closeTermsConfirmModal() {
    setTermsConfirmOpen(false);
    pendingTermsActionRef.current = null;
  }

  function handleTermsModalAgree() {
    setTermsAccepted(true);
    setTermsConfirmOpen(false);
    const action = pendingTermsActionRef.current;
    pendingTermsActionRef.current = null;
    if (action) {
      action();
    }
  }

  const stationAllowsReservation = isStationAllowReservation(station);
  const reservationMinutes = getReservationMinutes(station);
  const distanceToStationKm = useMemo(() => stationDistanceKmFromUser(station), [station]);

  // Calculate km per kWh based on temperature
  const getKmPerKwh = () => {
    if (temperature === null) return 5; // default: 20 kWh/100km
    if (temperature < 0) return 3.33; // 30 kWh/100km
    if (temperature < 10) return 4; // 25 kWh/100km
    return 5; // 20 kWh/100km
  };

  // Fetch temperature from Open-Meteo API
  useEffect(() => {
    const fetchTemperature = async () => {
      if (!station?.latitude || !station?.longitude) return;
      try {
        const response = await fetch(
          `https://api.open-meteo.com/v1/forecast?latitude=${station.latitude}&longitude=${station.longitude}&current=temperature_2m`
        );
        const data = await response.json();
        if (data?.current?.temperature_2m !== undefined) {
          setTemperature(data.current.temperature_2m);
        }
      } catch (error) {
        console.error('Failed to fetch temperature:', error);
      }
    };
    fetchTemperature();
  }, [station?.latitude, station?.longitude]);

  function priceCalculate(value) {
    const price = ((value * station?.costPerKwt) / 100).toString().split('.');
    return {
      whole: price[0],
      decimal: price[1],
    };
  }

  const autoStart = false;

  const { clientId, isLoading: isClientIdLoading } = useGetClientId();
  const {
    isEmsBound,
    isEmsLoading,
    maxSelectableKwh: maxKwhFromOpenEmsBattery,
    batteryCapacityKwh: emsBatteryCapacityKwh,
    shouldApplyBatteryLimit,
    socPercent: emsSocPercent,
    pvPowerW: emsPvPowerW,
    batteryPowerW: emsBatteryPowerW,
    insolationTodayPct: emsInsolationTodayPct,
    insolationTomorrowPct: emsInsolationTomorrowPct,
    openEmsLinkUrl,
  } = useOpenEmsEvPortBatteryLimit(stationNumber, {
    stationName: station?.name,
    latitude: station?.latitude,
    longitude: station?.longitude,
  });
  const { preferTelegram: preferTelegramForContact, lastPortForLink } = useContactUsTelegramPreferred();

  const socPriceTiers = useMemo(() => getSocPriceTiersFromStation(station), [station]);

  const effectiveChargeMax = useMemo(() => {
    if (!shouldApplyBatteryLimit || maxKwhFromOpenEmsBattery == null) return CUSTOM_CHARGE_MAX;
    return Math.min(CUSTOM_CHARGE_MAX, Math.max(0, maxKwhFromOpenEmsBattery));
  }, [shouldApplyBatteryLimit, maxKwhFromOpenEmsBattery]);
  const batteryBlocksCharge = shouldApplyBatteryLimit && maxKwhFromOpenEmsBattery === 0;

  const isOcppOrTokaPort = station?.protocolType === 'OCPP' || station?.protocolType === 'ROAMING_TOKA';

  const { data: freshBalance, refetch: refetchBalance } = useGetBalanceQuery(clientId, { skip: !clientId });

  const { data: ecRemaining } = useGetEcRemainingKwhQuery(
    { stationNumber },
    { skip: !clientId || !stationNumber, pollingInterval: 7000 }
  );
  const ecUsable = Boolean(ecRemaining?.usable && ecRemaining?.remainingKwh >= 5);
  const ecSliderMax = ecUsable
    ? Math.min(CUSTOM_CHARGE_MAX, Math.max(CUSTOM_CHARGE_MIN, Math.floor(ecRemaining.remainingKwh)))
    : CUSTOM_CHARGE_MAX;

  /**
   * Web (browser/PWA): do not allow selecting less UAH than the prepaid balance
   * (whole-kWh floor). Native app keeps the usual 1 kWh minimum.
   */
  const effectiveChargeMin = useMemo(() => {
    if (isNativeApp) return CUSTOM_CHARGE_MIN;
    if (!freshBalance || !costPerKwt || costPerKwt <= 0) return CUSTOM_CHARGE_MIN;
    const balance = Number(freshBalance);
    if (!Number.isFinite(balance) || balance < costPerKwt) return CUSTOM_CHARGE_MIN;
    const minKwhFromBalance = Math.floor(balance / costPerKwt);
    return Math.min(effectiveChargeMax, Math.max(CUSTOM_CHARGE_MIN, minKwhFromBalance));
  }, [isNativeApp, freshBalance, costPerKwt, effectiveChargeMax]);
  const { data: deviceStatus, refetch: refetchDeviceStatus } = useGetDeviceStatusQuery(
    { stationNumber },
    {
      skip: !stationNumber,
      pollingInterval: isOcppOrTokaPort ? 5000 : undefined,
    }
  );
  const {
    data: historyData,
    isLoading: isHistoryLoading,
    isError: isHistoryError,
  } = api.useGetHistoryDataQuery(clientId, { skip: !clientId });

  // Deep link: /start?station=N&refund=1 opens RefundRequestModal for latest session on this port.
  useEffect(() => {
    if (!refundDeepLinkPendingRef.current) return undefined;
    // Wait until history has loaded (or failed) so we can attach invoiceId when present.
    if (clientId && isHistoryLoading) return undefined;
    refundDeepLinkPendingRef.current = false;
    const port = String(stationNumber || searchParams.get('station') || '').trim();
    const items = Array.isArray(historyData) ? historyData : [];
    const match = items.find(item => {
      const itemPort = String(item?.plugNumber ?? item?.stationNumber ?? '').trim();
      const invoiceId = item?.invoiceId || '';
      if (!invoiceId || !port || itemPort !== port) return false;
      if (isEnergyCardInvoiceId(invoiceId) || String(invoiceId).includes('liquidBalance')) return false;
      return true;
    });
    setRefundSession({
      invoiceId: match?.invoiceId || '',
      jobId: match?.id ?? match?.jobId ?? null,
    });
    setRefundModalOpen(true);
    ReactGA.event({
      category: 'refund_request',
      action: 'open from url',
      label: port,
    });
    const next = new URLSearchParams(searchParams);
    next.delete('refund');
    setSearchParams(next, { replace: true });
    return undefined;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientId, isHistoryLoading, historyData]);

  const { data: stationStatus, refetch: refetchStationStatus } = useGetStationStatusQuery(
    { stationNumber },
    {
      skip: !stationNumber || !stationAllowsReservation,
      pollingInterval: stationAllowsReservation ? 15000 : undefined,
    }
  );
  const [createReservation, { isLoading: isReserving }] = useCreateReservationMutation();
  const [cancelReservation, { isLoading: isCancellingReservation }] = useCancelReservationMutation();
  const [fetchReservationDailyLimit, { data: reservationDailyLimit, isFetching: isReservationDailyLimitLoading }] =
    useLazyGetReservationDailyLimitQuery();

  const activeReservation =
    stationStatus?.activeReservationPresented && stationStatus?.activeReservation
      ? stationStatus.activeReservation
      : null;
  const reservedByOther = Boolean(activeReservation && !activeReservation.mine);
  const reservedByMe = Boolean(activeReservation?.mine);
  const occupiedByRoaming = Boolean(deviceStatus?.isOccupied || deviceStatus?.occupied);
  const blockPaymentUi = reservedByOther || occupiedByRoaming;

  useEffect(() => {
    if (!activeReservation?.reservedUntil) {
      setCountdownSeconds(null);
      return undefined;
    }
    const tick = () => {
      const diff = Math.max(0, Math.floor((new Date(activeReservation.reservedUntil).getTime() - Date.now()) / 1000));
      setCountdownSeconds(diff);
    };
    tick();
    const intervalId = setInterval(tick, 1000);
    return () => clearInterval(intervalId);
  }, [activeReservation?.reservedUntil]);

  const [bookCooldownSeconds, setBookCooldownSeconds] = useState(0);
  const lastJobStoppedOn = stationStatus?.lastJob?.stoppedOn;
  const lastJobState = stationStatus?.lastJob?.state;

  useEffect(() => {
    const lastJob = { stoppedOn: lastJobStoppedOn, state: lastJobState };
    const update = () => {
      const remaining = getPostJobBookCooldownSeconds(lastJob);
      setBookCooldownSeconds(remaining);
      return remaining;
    };
    if (update() <= 0) {
      return undefined;
    }
    const intervalId = setInterval(() => {
      if (update() <= 0) {
        clearInterval(intervalId);
      }
    }, 1000);
    return () => clearInterval(intervalId);
  }, [lastJobStoppedOn, lastJobState]);

  // Update port status when device status changes
  useEffect(() => {
    if (deviceStatus) {
      setPortStatus(prev => ({
        ...prev,
        isReady: deviceStatus.isReadyToStart || deviceStatus.readyToStart,
      }));
    }
  }, [deviceStatus]);

  function isChargeWithEnergyCard() {
    if (!ecUsable || !kwt) return false;
    return kwt <= (ecRemaining?.remainingKwh || 0);
  }

  function isChargeWithBalance() {
    return isChargeCoveredWithoutCheckout({
      costPerKwt,
      kwt,
      balanceCents: freshBalance,
      energyCardCovers: isChargeWithEnergyCard(),
    });
  }

  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (startFreeStatus === 'success') {
      dispatch(api?.util.upsertQueryData('getStationStatus', { stationNumber }, {}));
      navigate(`/charging?station=${stationNumber}`);
    }
  }, [startFreeStatus]);

  // Set slider to max kWh based on EC or balance
  useEffect(() => {
    if (isStarting) return;

    if (ecUsable && ecRemaining?.remainingKwh) {
      const maxKwh = Math.min(ecSliderMax, Math.max(CUSTOM_CHARGE_MIN, Math.floor(ecRemaining.remainingKwh)));
      setKwt(maxKwh);
      setCustomChargeValue(maxKwh);
      setSelectedPrice(() => (isChargeWithEnergyCard() ? 0 : priceCalculate(maxKwh)));
      localStorage.setItem('lastKwt', String(maxKwh));
      return;
    }

    if (!freshBalance || !costPerKwt) {
      // If balance is not loaded yet, use value from localStorage or default
      const lastKwt = localStorage.getItem('lastKwt');
      if (lastKwt === null) {
        localStorage.setItem('lastKwt', String(INITIAL_SLIDER_KWH));
        setKwt(INITIAL_SLIDER_KWH);
        setCustomChargeValue(INITIAL_SLIDER_KWH);
        setSelectedPrice(() => priceCalculate(INITIAL_SLIDER_KWH));
      } else {
        const savedValue = Number(lastKwt);
        const normalized = isNaN(savedValue)
          ? INITIAL_SLIDER_KWH
          : Math.min(effectiveChargeMax, Math.max(effectiveChargeMin, savedValue));
        setKwt(normalized);
        setCustomChargeValue(normalized);
        setSelectedPrice(() => priceCalculate(normalized));
      }
      return;
    }

    const balance = Number(freshBalance); // Balance is in kopecks (cents)
    const costFor1Kwh = costPerKwt; // costPerKwt is in kopecks per kWh

    // Check if balance is more than for 1 kWh
    if (balance > costFor1Kwh) {
      // Calculate max kWh that can be purchased with current balance
      // Both balance and costPerKwt are in kopecks, so simple division
      const maxKwhFromBalance = Math.floor(balance / costPerKwt);

      // Limit to slider range (balance + Open EMS battery headroom when bound)
      const maxKwh = Math.min(effectiveChargeMax, Math.max(effectiveChargeMin, maxKwhFromBalance));

      // Update slider to max value
      setKwt(maxKwh);
      setCustomChargeValue(maxKwh);
      setSelectedPrice(() => priceCalculate(maxKwh));
      localStorage.setItem('lastKwt', String(maxKwh));
    } else {
      // If balance is not enough for 1 kWh, use value from localStorage or default
      // But still limit it by balance if saved value exceeds balance
      const lastKwt = localStorage.getItem('lastKwt');
      if (lastKwt === null) {
        localStorage.setItem('lastKwt', String(INITIAL_SLIDER_KWH));
        setKwt(INITIAL_SLIDER_KWH);
        setCustomChargeValue(INITIAL_SLIDER_KWH);
        setSelectedPrice(() => priceCalculate(INITIAL_SLIDER_KWH));
      } else {
        const savedValue = Number(lastKwt);
        let normalized = isNaN(savedValue)
          ? INITIAL_SLIDER_KWH
          : Math.min(effectiveChargeMax, Math.max(effectiveChargeMin, savedValue));

        // Limit by balance if saved value exceeds balance
        const maxKwhFromBalance = Math.floor(balance / costPerKwt);
        const maxKwh = Math.min(effectiveChargeMax, Math.max(effectiveChargeMin, maxKwhFromBalance));
        if (normalized > maxKwh) {
          normalized = maxKwh;
        }

        setKwt(normalized);
        setCustomChargeValue(normalized);
        setSelectedPrice(() => priceCalculate(normalized));
      }
    }
  }, [
    freshBalance,
    costPerKwt,
    effectiveChargeMax,
    effectiveChargeMin,
    isStarting,
    ecUsable,
    ecRemaining,
    ecSliderMax,
  ]);

  useEffect(() => {
    if (isStarting) return;
    const clamped = Math.min(effectiveChargeMax, Math.max(effectiveChargeMin, customChargeValue));
    if (clamped === customChargeValue) return;
    setKwt(clamped);
    setCustomChargeValue(clamped);
    setSelectedPrice(() => priceCalculate(clamped));
    localStorage.setItem('lastKwt', String(clamped));
  }, [customChargeValue, effectiveChargeMax, effectiveChargeMin, isStarting]);

  useEffect(() => {
    // If any error occurs during start/payment link generation, stop showing loader
    if (error) {
      setIsStarting(false);
    }
  }, [error]);

  const dispatch = useDispatch();

  const { openPaymentLink, startChargingFree, skipPaymentAndStart } = startCharging();
  const showLocalSkipPayment = isLocalSkipPaymentEnabled();
  const isWorking = isWorkingTime(station, openFrom, closedFrom, isTwentyFourHour);
  const [triggerFreeTopup] = api.useLazyFreeTestChargeTopupQuery();

  const { t } = useTranslation();

  useEffect(() => {
    document.body.classList.add('b2b-route');
    const layout = document.getElementById('layout');
    layout?.classList.add('b2b-route-layout');
    return () => {
      document.body.classList.remove('b2b-route');
      layout?.classList.remove('b2b-route-layout');
    };
  }, []);

  const getOfflineMessage = () => getStationOfflineMessage(station, t);

  // Parse quickStartText from station name pattern: quickStartText:"xxx"
  const getQuickStartText = () => {
    if (!station?.name) return null;
    const match = station.name.match(/quickStartText:"([^"]+)"/);
    return match ? match[1] : null;
  };

  const customQuickStartText = getQuickStartText();

  // Wait for first history load only — ignore background refetch (Layout may poll on /charging).
  const isClientIdReady = !isClientIdLoading && !!clientId;
  const isHistoryReady = isClientIdReady && !isHistoryLoading && (historyData !== undefined || isHistoryError);
  const canLeaveFeedback =
    isHistoryError || !isHistoryReady || paidPortsInHistory(historyData, reportStationNumbers).length > 0;
  const totalEnergyKwh = historyData ? historyData.reduce((sum, item) => sum + (item.energyWth || 0), 0) / 1000 : null;
  const hasZeroEnergy = isHistoryReady && totalEnergyKwh !== null && totalEnergyKwh === 0;
  const quickStartEligible = hasZeroEnergy && !isInService && !isNativeApp && canOfferFreeStart;
  const canReservePort = isNativeApp || isReservationWhitelistClient(clientId);

  function resolveReservationErrorMessage(code) {
    switch (code) {
      case 'IP_DAILY_LIMIT':
      case 'CLIENT_DAILY_LIMIT':
        return t('reservation.dailyLimitExceeded');
      case 'PORT_ALREADY_RESERVED':
        return t('reservation.portAlreadyReserved');
      case 'RESERVATION_NOT_ALLOWED':
        return t('reservation.notAllowed');
      case 'ACTIVE_JOB_PRESENT':
        return t('reservation.portBusy');
      case 'POST_JOB_COOLDOWN':
        return t('reservation.postJobCooldown');
      case 'RESERVATION_NOT_ELIGIBLE':
      case 'NATIVE_APP_REQUIRED':
        return t('reservation.notEligible');
      case 'LOCATION_REQUIRED':
        return t('reservation.locationRequired');
      default:
        return t('reservation.failed');
    }
  }

  function showReservationError(code) {
    setReservationErrorMessage(resolveReservationErrorMessage(code));
    setReservationErrorOpen(true);
  }

  function handleOpenReservationConfirm() {
    if (isReserving || !stationNumber || bookCooldownSeconds > 0) return;
    if (occupiedByRoaming) {
      setReservationErrorMessage(t('reservation.portBusy'));
      setReservationErrorOpen(true);
      return;
    }
    setReservationConfirmOpen(true);
    fetchReservationDailyLimit();
  }

  function handleGuestPayYes() {
    setGuestPayConfirmOpen(false);
    ReactGA.event({
      category: 'guestPay',
      action: 'confirm guest pay in browser',
    });
    payAndCharge(customChargeValue);
  }

  function handleGuestPayInstallApp() {
    ReactGA.event({
      category: 'installApp',
      action: 'start page guest pay install app popup',
    });
    setGuestPayConfirmOpen(false);
    navigate(`/install-app?station=${encodeURIComponent(stationNumber ?? '')}`);
  }

  function handlePayButtonClick() {
    if (isStarting || batteryBlocksCharge) return;
    handleTermsGatedAction(() => {
      // Browser only: ask guest vs install app before payment gateway (not when paying with balance)
      if (!isNativeApp && !isChargeWithBalance() && !isChargeWithEnergyCard()) {
        setGuestPayConfirmOpen(true);
        return;
      }
      payAndCharge(customChargeValue);
    });
  }

  async function handleConfirmReservation() {
    if (isReserving || !stationNumber) return;
    if (reservationDailyLimit?.remainingToday === 0) {
      showReservationError('CLIENT_DAILY_LIMIT');
      setReservationConfirmOpen(false);
      return;
    }
    const reserved = await handleReservePort();
    if (reserved) {
      setReservationConfirmOpen(false);
    }
  }

  async function handleReservePort() {
    if (isReserving || !stationNumber) return false;
    try {
      const result = await createReservation({ stationNumber }).unwrap();
      if (!result?.success) {
        showReservationError(result?.error || 'RESERVATION_FAILED');
        return false;
      }
      refetchStationStatus();
      return true;
    } catch (err) {
      showReservationError(getReservationErrorCode(err) || 'RESERVATION_FAILED');
      return false;
    }
  }

  async function handleCancelReservation() {
    if (isCancellingReservation || !stationNumber) return;
    try {
      await cancelReservation({ stationNumber }).unwrap();
      refetchStationStatus();
    } catch {
      setReservationErrorMessage(t('reservation.failed'));
      setReservationErrorOpen(true);
    }
  }

  function renderReservationStatus() {
    if (occupiedByRoaming) {
      return (
        <Card className="start-panel-card" style={{ marginBottom: '16px' }}>
          <Box sx={{ textAlign: 'center', py: 2 }}>
            <p className="start-charge-label">{t('reservation.portBusy')}</p>
          </Box>
        </Card>
      );
    }

    if (!stationAllowsReservation) {
      return null;
    }

    if (reservedByOther) {
      return (
        <Card className="start-panel-card" style={{ marginBottom: '16px' }}>
          <Box sx={{ textAlign: 'center', py: 2 }}>
            <p className="start-charge-label">{t('reservation.reservedByOther')}</p>
            <p className="start-charge-value" style={{ fontSize: '32px', marginTop: '12px' }}>
              {t('reservation.countdown', { time: formatReservationCountdown(countdownSeconds ?? 0) })}
            </p>
          </Box>
        </Card>
      );
    }

    if (reservedByMe) {
      return (
        <Card className="start-panel-card" style={{ marginBottom: '16px' }}>
          <Box sx={{ textAlign: 'center', py: 2 }}>
            <p className="start-charge-label">{t('reservation.reservedByYou')}</p>
            <p className="start-charge-value" style={{ fontSize: '32px', marginTop: '12px' }}>
              {t('reservation.countdown', { time: formatReservationCountdown(countdownSeconds ?? 0) })}
            </p>
            <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
              <Button
                variant="outline-alt"
                className={getActionButtonLoadingClassName(isCancellingReservation, true)}
                style={START_PAGE_ACTION_BUTTON_STYLE}
                disabled={isCancellingReservation}
                aria-busy={isCancellingReservation}
                onClick={handleCancelReservation}
              >
                {isCancellingReservation ? <ActionButtonSpinner /> : t('reservation.cancel')}
              </Button>
            </Box>
          </Box>
        </Card>
      );
    }

    return null;
  }

  function renderReserveButton() {
    if (!stationAllowsReservation || !canReservePort || reservedByMe || reservedByOther || occupiedByRoaming) {
      return null;
    }

    const bookCooldownActive = bookCooldownSeconds > 0;
    const bookCooldownLabel = formatReservationCountdown(bookCooldownSeconds);

    return (
      <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', mt: '16px' }}>
        <Button
          variant="outline-alt"
          className={getActionButtonLoadingClassName(isReserving, true)}
          style={START_PAGE_ACTION_BUTTON_STYLE}
          disabled={isReserving || bookCooldownActive}
          aria-busy={isReserving}
          aria-live="polite"
          onClick={handleOpenReservationConfirm}
        >
          {isReserving ? (
            <ActionButtonSpinner outline />
          ) : (
            <span
              style={{
                fontSize: bookCooldownActive ? '22px' : '26px',
                letterSpacing: bookCooldownActive ? '1px' : '2px',
                padding: '0 16px',
                fontVariantNumeric: 'tabular-nums',
              }}
            >
              {bookCooldownActive
                ? t('reservation.btnReserveCooldown', { time: bookCooldownLabel })
                : t('reservation.btnReserve')}
            </span>
          )}
        </Button>
      </Box>
    );
  }

  async function payAndCharge(amount) {
    const safeAmount = Math.min(effectiveChargeMax, Math.max(effectiveChargeMin, Number(amount) || effectiveChargeMin));
    localStorage.setItem('lastKwt', String(safeAmount));

    // Check if clientId is saved in localStorage
    const savedClientId = localStorage.getItem('clientId');
    if (!savedClientId) {
      setError('CLIENT_ID_NOT_READY');
      setIsStarting(false);
      return;
    }

    if (occupiedByRoaming) {
      setReservationErrorMessage(t('reservation.portBusy'));
      setReservationErrorOpen(true);
      return;
    }

    if (!portStatus.isReady) {
      setPortErrorOpen(true);
      return;
    }

    setIsStarting(true);

    ReactGA.event({
      category: `start_${safeAmount}_kWt`,
      action: `start_${safeAmount}_kWt`,
    });

    await openPaymentLink(stationNumber, safeAmount, autoStart, setError);
  }

  async function skipPaymentAndCharge(amount) {
    const safeAmount = Math.min(effectiveChargeMax, Math.max(effectiveChargeMin, Number(amount) || effectiveChargeMin));
    localStorage.setItem('lastKwt', String(safeAmount));

    const savedClientId = localStorage.getItem('clientId');
    if (!savedClientId) {
      setError('CLIENT_ID_NOT_READY');
      setIsStarting(false);
      return;
    }

    if (occupiedByRoaming) {
      setReservationErrorMessage(t('reservation.portBusy'));
      setReservationErrorOpen(true);
      return;
    }

    if (!portStatus.isReady) {
      setPortErrorOpen(true);
      return;
    }

    setIsStarting(true);

    ReactGA.event({
      category: 'skip_payment_local',
      action: `skip_payment_${safeAmount}_kWt`,
    });

    await skipPaymentAndStart(stationNumber, safeAmount, autoStart, setError);
  }

  function handleSkipPaymentClick() {
    if (isStarting || batteryBlocksCharge) return;
    handleTermsGatedAction(() => {
      skipPaymentAndCharge(customChargeValue);
    });
  }

  // Handle Quick Start button click (only when station has firstStartIsFree)
  async function handleQuickStart() {
    if (occupiedByRoaming) {
      setReservationErrorMessage(t('reservation.portBusy'));
      setReservationErrorOpen(true);
      return;
    }

    if (!portStatus.isReady) {
      setPortErrorOpen(true);
      return;
    }

    if (!canOfferFreeStart) {
      setQuickStartLoading(false);
      setIsStarting(false);
      return;
    }
    if (isNativeShellApp()) {
      setNativeAppFreeChargeOpen(true);
      return;
    }

    setQuickStartLoading(true);
    setIsStarting(true);

    try {
      const { error } = await triggerFreeTopup({ stationNumber });

      if (error) {
        console.error('Free test charge topup failed:', error);

        // Check for specific error codes
        const errorCode = error?.data?.error || error?.data?.data?.error;
        if (errorCode === 'FREE_CHARGE_ALREADY_USED') {
          setFreeChargeErrorOpen(true);
          setQuickStartLoading(false);
          setIsStarting(false);
          return;
        }

        if (errorCode === 'RATE_LIMITED') {
          setRateLimitErrorOpen(true);
          setQuickStartLoading(false);
          setIsStarting(false);
          return;
        }

        if (errorCode === 'FREE_CHARGE_NATIVE_APP_NOT_ALLOWED') {
          setNativeAppFreeChargeOpen(true);
          setQuickStartLoading(false);
          setIsStarting(false);
          return;
        }

        setError('FREE_TOPUP_FAILED');
        setQuickStartLoading(false);
        setIsStarting(false);
        return;
      }

      // Wait for balance to be updated
      // Poll balance until it's updated (with timeout)
      const maxAttempts = 10;
      let attempts = 0;
      let balanceUpdated = false;

      while (attempts < maxAttempts && !balanceUpdated) {
        await new Promise(resolve => setTimeout(resolve, 500)); // Wait 500ms between checks
        const { data: updatedBalance } = await refetchBalance();

        if (updatedBalance && Number(updatedBalance) > 0) {
          balanceUpdated = true;
        }
        attempts++;
      }

      if (!balanceUpdated) {
        console.error('Balance was not updated after topup');
        setError('BALANCE_UPDATE_TIMEOUT');
        setQuickStartLoading(false);
        setIsStarting(false);
        return;
      }

      ReactGA.event({
        category: 'quick_start',
        action: 'free_charge_started',
      });

      // Start 1 kWh charge with autoStart=true
      await openPaymentLink(stationNumber, 1, true, setError);
    } catch (err) {
      console.error('Quick start error:', err);
      setError('QUICK_START_FAILED');
      setQuickStartLoading(false);
      setIsStarting(false);
    }
  }

  function mainButtonText() {
    return `${parseFloat((customChargeValue * station?.costPerKwt) / 100).toFixed(0)} ${t('currency')}
     ${t('forKwh')}
     ${customChargeValue} ${t('powerWt')}`;
  }

  // Reusable block with all visible port details (used on main and offline pages)
  const emsCarouselProps = {
    isEmsBound,
    isEmsLoading,
    insolationTodayPct: emsInsolationTodayPct,
    insolationTomorrowPct: emsInsolationTomorrowPct,
    pvPowerW: emsPvPowerW,
    socPercent: emsSocPercent,
    batteryCapacityKwh: emsBatteryCapacityKwh,
    batteryPowerW: emsBatteryPowerW,
    socPriceTiers,
    latitude: station?.latitude,
    longitude: station?.longitude,
    openEmsInverterUrl: openEmsLinkUrl,
    showBatteryPower: false,
  };

  const showEmsLayout = isEmsBound || isEmsLoading;
  const startPanelCardClassName = `start-panel-card${showEmsLayout ? ' green-energy-main-card' : ''}`;
  const startPanelCardStyle = showEmsLayout ? { marginBlock: 0, scrollSnapAlign: 'center' } : undefined;

  function renderPortDetails() {
    return (
      <>
        <ChargingPortCard
          station={station}
          stationNumber={stationNumber}
          socPercent={emsSocPercent}
          style={{
            width: '100%',
            marginBlock: '10px',
          }}
        />
        {!isTwentyFourHour && (
          <Row id="startPageTitleBox" className="justify-content-center mt-3 mb-3 pr-1 pl-1">
            <p className="delayedStartTime">
              <Trans i18nKey={'delayedInfo'}>
                Порт працює з {{ openFrom }} до
                {{ closedFrom }}
              </Trans>
            </p>
          </Row>
        )}
      </>
    );
  }

  function renderEndShareButton() {
    const ports = endSharePorts.length ? endSharePorts : stationNumber ? [String(stationNumber)] : [];
    if (!ports.length) {
      return null;
    }
    return (
      <div className="start-page-share-end">
        <StartManyShareButton
          ports={ports}
          showPrintOrder
          printStationNumber={stationNumber}
          className="layout-page-chrome-btn"
        />
      </div>
    );
  }

  if (error) {
    // Check if error is related to payment configuration
    if (typeof error === 'string' && error.includes('Payment Not configured')) {
      // Extract detailed message without the "Payment Not configured" prefix to avoid duplication
      // Remove various forms: "Payment Not configured", "Payment Not configured:", etc.
      let detailedMessage = error
        .replace(/^Payment\s+Not\s+configured:?\s*/i, '')
        .replace(/^Оплата\s+не\s+(налаштована|настроена):?\s*/i, '')
        .trim();

      // If no detailed message after removing prefix, use a generic message
      if (!detailedMessage || detailedMessage === error || detailedMessage.length === 0) {
        detailedMessage = t('errorPayBody');
      }

      return (
        <ErrorPage
          centerOnScreen
          errorHeader={t('paymentNotConfigured')}
          errorBody={detailedMessage}
          stationNumber={stationNumber}
        />
      );
    }
    const inService = isStationInService(station);
    const inServiceBody = getPortInServiceMessage(station, t);
    return (
      <ErrorPage
        errorHeader={inService ? undefined : t('stationOffline')}
        errorBody={inService ? inServiceBody : getOfflineMessage()}
        hideContactUs={inService}
        isInServicePage={inService}
        stationNumber={stationNumber}
        afterMessageChildren={
          inService ? undefined : (
            <Button
              type="button"
              variant="outline"
              className="error-page-notify-btn"
              onClick={() => {
                ReactGA.event({
                  category: 'contacts',
                  action: 'notify when online',
                });
                window.open(
                  `https://t.me/${TELEGRAM_BOT}?start=${encodeURIComponent(clientId || 'web')}-notify_${stationNumber || ''}`,
                  '_blank'
                );
              }}
            >
              <span>{t('notifyWhenOnline')}</span>
            </Button>
          )
        }
        footerChildren={
          inService ? undefined : (
            <>
              <Button
                type="button"
                variant="outline"
                className="error-page-action-btn"
                style={{ marginTop: '14px' }}
                onClick={() => setMapsModalOpen(true)}
              >
                <span>{t('route')}</span>
              </Button>
              <OutageScheduleButton
                latitude={station?.latitude}
                longitude={station?.longitude}
                stationNumber={stationNumber}
                className="error-page-action-btn"
                style={{ marginTop: '14px' }}
                labelStyle={null}
              />
              {canShowRestartStation({ station, stationNumber, historyData, isHistoryReady }) ? (
                <Box className="start-page-footer-actions">
                  <RestartStationButton
                    station={station}
                    stationNumber={stationNumber}
                    historyData={historyData}
                    isHistoryReady={isHistoryReady}
                  />
                </Box>
              ) : null}
              <StationPublicReportsSection
                stationNumbers={reportStationNumbers}
                reloadToken={reportsReload}
                onFeedback={() => setFeedbackModalOpen(true)}
                onService={() => setServiceRequestModalOpen(true)}
              />
              {renderEndShareButton()}
              <OpenMapsConfirmModal
                modalOpen={mapsModalOpen}
                setModalOpen={setMapsModalOpen}
                latitude={station?.latitude}
                longitude={station?.longitude}
                stationNumber={stationNumber}
              />
              <ServiceRequestModal
                modalOpen={serviceRequestModalOpen}
                setModalOpen={setServiceRequestModalOpen}
                station={station}
                stationNumber={stationNumber}
                clientId={clientId}
                onSubmitted={bumpReports}
              />
            </>
          )
        }
      >
        <div className="start-page-root" style={{ width: '100%' }}>
          <StartManyLocationHeader
            stations={[station]}
            showShare
            showPrintOrder
            showMap={false}
            shareAtEnd
            onSharePorts={handleSharePorts}
          />
          <div id="startPage" style={{ maxWidth: '600px', margin: '0 auto', width: '100%' }}>
            {!(station?.latitude != null && station?.longitude != null) ? (
              <StartPageTopOnlineStatus station={station} />
            ) : null}
            {renderPortDetails()}
            <StartPageStationNotes station={station} />
            <StationMediaCarousel
              stationNumber={stationNumber}
              protocolType={station?.protocolType}
              webcamUrl={station?.webcamUrl}
            />
          </div>
        </div>
      </ErrorPage>
    );
  }

  const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
  const lang = localStorage.getItem('i18nextLng');
  const showInstall220AppHint = !isNativeApp && !isPwaStandaloneDisplay() && isLikelyMobileOrTabletUa();
  const hasEmbedMap = station?.latitude != null && station?.longitude != null;

  return (
    <div
      className={`start-page-root${showEmsLayout ? ' start-page-root--ems' : ''}${hasEmbedMap ? ' start-page-root--with-map' : ''}`}
      style={{
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        flexDirection: 'column',
        overflow: 'visible',
        width: '100%',
        maxWidth: '100vw',
        minWidth: 0,
        boxSizing: 'border-box',
      }}
    >
      <StartManyLocationHeader
        stations={station ? [station] : []}
        showShare
        showPrintOrder
        showMap={false}
        shareAtEnd
        onSharePorts={handleSharePorts}
      />
      <div
        id="startPage"
        className={showEmsLayout ? 'start-page--ems-bound' : undefined}
        style={{
          width: '100%',
          maxWidth: showEmsLayout ? undefined : '600px',
          overflow: 'visible',
          boxSizing: 'border-box',
        }}
      >
        {!hasEmbedMap ? <StartPageTopOnlineStatus station={station} /> : null}
        <Box
          className="start-page-content-wrap"
          sx={{ m: hasEmbedMap ? { xs: '4px 12px 16px', md: '8px 7% 10%' } : { xs: '16px 12px', md: '10% 7%' } }}
        >
          {renderPortDetails()}
          <Box sx={{ m: { xs: '24px 0', md: '40px 0' } }}>
            {renderReservationStatus()}
            {isInRepair ? (
              <Card className="start-panel-card">
                <Box sx={{ textAlign: 'center', py: 3 }}>
                  <p className="start-charge-value" style={{ fontSize: '32px', margin: 0 }}>
                    {getPortInRepairMessage(station, t)}
                  </p>
                </Box>
              </Card>
            ) : !isClientIdReady || !isHistoryReady ? (
              // Show loader while waiting for client id or history
              <Card className="start-panel-card">
                <Box
                  width="100%"
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  position="relative"
                  sx={{ py: '40px' }}
                >
                  <LoadingSm />
                </Box>
              </Card>
            ) : blockPaymentUi ? null : quickStartEligible ? (
              <StartPageEmsCarousel {...emsCarouselProps}>
                <Card className={startPanelCardClassName} style={startPanelCardStyle}>
                  <Box
                    width="100%"
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    position="relative"
                    sx={{
                      mb: '20px',
                      px: '20px',
                      flexDirection: 'column',
                      gap: customQuickStartText ? 0 : '16px',
                      alignItems: 'center',
                    }}
                  >
                    {customQuickStartText ? (
                      <span
                        className="start-charge-label"
                        style={{ textAlign: 'center', width: '100%', display: 'block', padding: '0 20px' }}
                      >
                        {customQuickStartText}
                      </span>
                    ) : (
                      <>
                        <span
                          className="start-charge-value"
                          style={{ textAlign: 'center', width: '100%', display: 'block', padding: '0 20px' }}
                        >
                          {t('quickStart.headline')}
                        </span>
                        <span
                          className="start-charge-label"
                          style={{
                            textAlign: 'center',
                            width: '100%',
                            display: 'block',
                            lineHeight: 1.45,
                            padding: '0 8px',
                          }}
                        >
                          {t('quickStart.intro')}
                        </span>
                        <span
                          className="start-charge-label"
                          style={{
                            textAlign: 'center',
                            width: '100%',
                            display: 'block',
                            lineHeight: 1.4,
                            padding: '0 8px',
                            opacity: 0.95,
                          }}
                        >
                          {t('quickStart.afterSessionHint')}
                        </span>
                      </>
                    )}
                  </Box>
                  <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                    <Button
                      variant=""
                      className={getActionButtonLoadingClassName(quickStartLoading || isStarting)}
                      style={START_PAGE_ACTION_BUTTON_STYLE}
                      disabled={quickStartLoading || isStarting}
                      aria-busy={quickStartLoading || isStarting}
                      onClick={() => {
                        if (quickStartLoading || isStarting) return;
                        handleTermsGatedAction(() => handleQuickStart());
                      }}
                    >
                      {quickStartLoading || isStarting ? (
                        <ActionButtonSpinner />
                      ) : (
                        <span
                          style={{
                            fontSize: '26px',
                            letterSpacing: '4.3px',
                          }}
                        >
                          {t('quickStart.button') || 'Start'}
                        </span>
                      )}
                    </Button>
                  </Box>
                  {showLocalSkipPayment ? (
                    <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', mt: '12px' }}>
                      <Button
                        variant="outline"
                        className={getActionButtonLoadingClassName(isStarting, true)}
                        style={{
                          ...START_PAGE_ACTION_BUTTON_STYLE,
                          width: '100%',
                          maxWidth: '320px',
                        }}
                        disabled={isStarting || batteryBlocksCharge}
                        aria-busy={isStarting}
                        onClick={handleSkipPaymentClick}
                      >
                        {isStarting ? (
                          <ActionButtonSpinner outline />
                        ) : (
                          <span style={{ fontSize: '16px', letterSpacing: '0.04em', lineHeight: 1.2 }}>
                            {t('b2bMarketplacePayTestSkip')}
                          </span>
                        )}
                      </Button>
                    </Box>
                  ) : null}
                  <DriverTermsAcceptToggle
                    checked={termsAccepted}
                    onChange={handleTermsAcceptedChange}
                    id="driver-terms-quick"
                  />
                  {renderReserveButton()}
                </Card>
              </StartPageEmsCarousel>
            ) : (
              // Regular slider section for users with energy history
              <StartPageEmsCarousel {...emsCarouselProps}>
                <Card className={startPanelCardClassName} style={startPanelCardStyle}>
                  <Box className="start-charge-hero">
                    <Box className="start-charge-primary-row">
                      <span className="start-charge-primary-value start-charge-num-slot start-charge-num-slot--kwh">
                        {customChargeValue}
                      </span>
                      <span className="start-charge-primary-unit">{t('wt').trim()}</span>
                    </Box>
                    <Box
                      className="start-charge-metrics-row start-charge-metrics-row--secondary"
                      aria-label="Price and range"
                    >
                      <div className="start-charge-metric-group start-charge-metric-group--price">
                        <span className="start-charge-metric-value start-charge-num-slot start-charge-num-slot--price">
                          {selectedPrice.whole}
                        </span>
                        <span className="start-charge-metric-unit">{t('currency').trim()}</span>
                      </div>
                      <span className="start-charge-metrics-sep" aria-hidden="true">
                        ·
                      </span>
                      <div className="start-charge-metric-group start-charge-metric-group--km">
                        <span className="start-charge-metric-value start-charge-num-slot start-charge-num-slot--km">
                          {Math.round(customChargeValue * getKmPerKwh())}
                        </span>
                        <span className="start-charge-km-unit">{t('km').trim()}</span>
                      </div>
                    </Box>
                  </Box>
                  <div className="start-charge-slider-wrap">
                    <Slider
                      min={CUSTOM_CHARGE_MIN}
                      selectableMin={effectiveChargeMin}
                      step={CUSTOM_CHARGE_STEP}
                      max={ecUsable ? ecSliderMax : effectiveChargeMax}
                      value={customChargeValue}
                      text={t('chooseVolume')}
                      onChange={(event, value) => {
                        if (!isIOS && navigator.vibrate) {
                          navigator.vibrate(1); // Vibrates for 1ms
                        }
                        const next = Math.min(effectiveChargeMax, Math.max(effectiveChargeMin, value));
                        setCustomChargeValue(next);
                        setKwt(next);
                        setSelectedPrice(() => priceCalculate(next));
                      }}
                    />
                  </div>

                  <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                    <Button
                      variant={isChargeWithBalance() ? '' : 'outline-alt'}
                      className={`${getActionButtonLoadingClassName(isStarting, !isChargeWithBalance())}${
                        isChargeWithEnergyCard() ? ` ${buttonStyles.buttonFitText}` : ''
                      }`}
                      style={{
                        ...START_PAGE_ACTION_BUTTON_STYLE,
                        ...(isChargeWithEnergyCard() ? { width: '100%', maxWidth: '320px' } : null),
                      }}
                      disabled={isStarting || batteryBlocksCharge}
                      aria-busy={isStarting}
                      onClick={handlePayButtonClick}
                    >
                      {isStarting ? (
                        <ActionButtonSpinner />
                      ) : (
                        <span
                          style={
                            isChargeWithEnergyCard()
                              ? {
                                  fontSize: 'clamp(15px, 4.2vw, 20px)',
                                  letterSpacing: '0.04em',
                                  lineHeight: 1.2,
                                  whiteSpace: 'normal',
                                  textAlign: 'center',
                                  display: 'block',
                                  width: '100%',
                                }
                              : {
                                  fontSize: '26px',
                                  letterSpacing: '4.3px',
                                }
                          }
                        >
                          {isChargeWithEnergyCard()
                            ? t('energyCard.chargeWithEc')
                            : isChargeWithBalance()
                              ? t('btnPayFor')
                              : t('btnPay')}
                        </span>
                      )}
                    </Button>
                  </Box>
                  {showLocalSkipPayment ? (
                    <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', mt: '12px' }}>
                      <Button
                        variant="outline"
                        className={getActionButtonLoadingClassName(isStarting, true)}
                        style={{
                          ...START_PAGE_ACTION_BUTTON_STYLE,
                          width: '100%',
                          maxWidth: '320px',
                        }}
                        disabled={isStarting || batteryBlocksCharge}
                        aria-busy={isStarting}
                        onClick={handleSkipPaymentClick}
                      >
                        {isStarting ? (
                          <ActionButtonSpinner outline />
                        ) : (
                          <span style={{ fontSize: '16px', letterSpacing: '0.04em', lineHeight: 1.2 }}>
                            {t('b2bMarketplacePayTestSkip')}
                          </span>
                        )}
                      </Button>
                    </Box>
                  ) : null}
                  <DriverTermsAcceptToggle
                    checked={termsAccepted}
                    onChange={handleTermsAcceptedChange}
                    id="driver-terms-pay"
                  />
                  {renderReserveButton()}
                </Card>
              </StartPageEmsCarousel>
            )}
          </Box>
          <StartPageStationNotes station={station} />
          <br />
          {showInstall220AppHint && (
            <Button
              variant="outline"
              className={buttonStyles.buttonFitText}
              style={{
                display: 'flex',
                gap: '6px',
                margin: 'auto',
                width: '86%',
                maxWidth: '100%',
                ...START_PAGE_ACTION_BUTTON_STYLE,
              }}
              onClick={() => {
                ReactGA.event({
                  category: 'installApp',
                  action: 'start page install 220 app outline button',
                });
                navigate(`/install-app?station=${encodeURIComponent(stationNumber ?? '')}`);
              }}
            >
              <span>{t('installApp')}</span>
            </Button>
          )}
          <Button
            variant="outline"
            style={{
              display: 'flex',
              gap: '6px',
              margin: showInstall220AppHint ? '20px auto 0' : 'auto',
              width: '86%',
              ...START_PAGE_ACTION_BUTTON_STYLE,
            }}
            onClick={() => {
              // If user's last charging session was on a port with power < 30 kW, open Telegram instead of phone modal
              if (preferTelegramForContact && clientId) {
                ReactGA.event({
                  category: 'contacts',
                  action: 'telegram from start page (last session port < 30 kW)',
                });
                window.open(
                  `https://t.me/${TELEGRAM_BOT}?start=${encodeURIComponent(clientId)}-${lastPortForLink || stationNumber || ''}`,
                  '_blank'
                );
              } else {
                setIsOpenModal(true);
              }
            }}
          >
            {/*<Icon i="phone" size="32px" />*/}
            <span
              style={{
                fontSize: '24px',
                fontWeight: '300',
                letterSpacing: '2px',
              }}
            >
              {t('contactUs')}
            </span>
          </Button>
          {station?.plugshareLink && (
            <Button
              link={station?.plugshareLink}
              variant="outline"
              style={{
                display: 'flex',
                gap: '12px',
                margin: '45px auto',
                width: '86%',
              }}
            >
              <span
                style={{
                  fontSize: '24px',
                  fontWeight: '300',
                  letterSpacing: '2px',
                }}
              >
                Plugshare
              </span>
            </Button>
          )}
          <Button
            type="button"
            variant="outline"
            style={{
              display: 'flex',
              gap: '12px',
              margin: '45px auto',
              width: '86%',
            }}
            onClick={() => setMapsModalOpen(true)}
          >
            {/*<Icon i="feedback" size="36px" />*/}
            <span
              style={{
                fontSize: '24px',
                fontWeight: '300',
                letterSpacing: '2px',
              }}
            >
              {t('route')}
            </span>
          </Button>
          <OutageScheduleButton
            latitude={station?.latitude}
            longitude={station?.longitude}
            stationNumber={stationNumber}
            className={buttonStyles.buttonPhoneLabel}
            labelStyle={null}
            style={{
              display: 'flex',
              gap: '12px',
              margin: '45px auto',
              width: '86%',
            }}
          />
        </Box>
      </div>

      <OpenMapsConfirmModal
        modalOpen={mapsModalOpen}
        setModalOpen={setMapsModalOpen}
        latitude={station?.latitude}
        longitude={station?.longitude}
        stationNumber={stationNumber}
      />
      {isOpenModal && <ModalContacts setModalOpen={setIsOpenModal} modalOpen={isOpenModal} />}
      {feedbackModalOpen && (
        <LeaveFeedbackModal
          modalOpen={feedbackModalOpen}
          setModalOpen={setFeedbackModalOpen}
          station={station}
          stationNumber={stationNumber}
          clientId={clientId}
          canLeaveFeedback={canLeaveFeedback}
          onSubmitted={bumpReports}
        />
      )}
      <ServiceRequestModal
        modalOpen={serviceRequestModalOpen}
        setModalOpen={setServiceRequestModalOpen}
        station={station}
        stationNumber={stationNumber}
        clientId={clientId}
        onSubmitted={bumpReports}
      />
      <RefundRequestModal
        modalOpen={refundModalOpen}
        setModalOpen={setRefundModalOpen}
        stationNumber={stationNumber}
        clientId={clientId}
        invoiceId={refundSession.invoiceId}
        jobId={refundSession.jobId}
      />
      {portErrorOpen && (
        <Modal setModalOpen={setPortErrorOpen} modalOpen={portErrorOpen}>
          <h1 className="delayedStartWarning">
            {t('errorStart.portConnectedQuestion', { portNumber: stationNumber })}
            <br />
            <br />
            {t('errorStart.ifSoPleaseDo')}
            <br />
            {t('errorStart.alertMessage')}
          </h1>
          <br />
          <Button
            onClick={() => setPortErrorOpen(false)}
            className="mainBtn buttonForOfflineStation"
            style={{ display: 'block', margin: '0 auto' }}
          >
            <span className="mainBtnText">OK</span>
          </Button>
        </Modal>
      )}
      {freeChargeErrorOpen && (
        <Modal setModalOpen={setFreeChargeErrorOpen} modalOpen={freeChargeErrorOpen}>
          <h1 className="delayedStartWarning">{t('freeChargeError.title')}</h1>
          <p style={{ fontSize: '18px', marginBottom: '24px', color: '#fff9', lineHeight: '1.5' }}>
            {t('freeChargeError.message')}
          </p>
          <Button
            onClick={() => setFreeChargeErrorOpen(false)}
            className="mainBtn buttonForOfflineStation"
            style={{ display: 'block', margin: '0 auto' }}
          >
            <span className="mainBtnText">OK</span>
          </Button>
        </Modal>
      )}
      {rateLimitErrorOpen && (
        <Modal setModalOpen={setRateLimitErrorOpen} modalOpen={rateLimitErrorOpen}>
          <h1 className="delayedStartWarning">{t('rateLimitError.title')}</h1>
          <p style={{ fontSize: '18px', marginBottom: '24px', color: '#fff9', lineHeight: '1.5' }}>
            {t('rateLimitError.message')}
          </p>
          <Button
            onClick={() => setRateLimitErrorOpen(false)}
            className="mainBtn buttonForOfflineStation"
            style={{ display: 'block', margin: '0 auto' }}
          >
            <span className="mainBtnText">OK</span>
          </Button>
        </Modal>
      )}
      {reservationConfirmOpen && (
        <Modal setModalOpen={setReservationConfirmOpen} modalOpen={reservationConfirmOpen}>
          <h1 className="delayedStartWarning">{t('reservation.detailsTitle')}</h1>
          <ul
            style={{
              fontSize: '18px',
              marginBottom: '24px',
              color: '#fff9',
              lineHeight: '1.6',
              paddingLeft: '20px',
              textAlign: 'left',
            }}
          >
            <li>{t('reservation.detailsPort', { port: stationNumber })}</li>
            <li>{t('reservation.detailsDuration', { minutes: reservationMinutes })}</li>
            <li>
              {distanceToStationKm != null
                ? t('reservation.detailsDistance', { distance: distanceToStationKm })
                : t('reservation.detailsDistanceUnknown')}
            </li>
            {isReservationDailyLimitLoading ? (
              <li>{t('reservation.detailsAttemptsLoading')}</li>
            ) : (
              <li>
                {t('reservation.detailsAttempts', {
                  used: reservationDailyLimit?.usedToday ?? 0,
                  max: reservationDailyLimit?.maxPerDay ?? 1,
                })}
              </li>
            )}
          </ul>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px', alignItems: 'center' }}>
            <Button
              onClick={handleConfirmReservation}
              className={`mainBtn buttonForOfflineStation ${getActionButtonLoadingClassName(isReserving)}`}
              disabled={isReserving || isReservationDailyLimitLoading || reservationDailyLimit?.remainingToday === 0}
              aria-busy={isReserving}
              style={{ display: 'block', margin: '0 auto', minWidth: '200px' }}
            >
              {isReserving ? (
                <ActionButtonSpinner />
              ) : (
                <span className="mainBtnText">{t('reservation.detailsConfirm')}</span>
              )}
            </Button>
            <Button
              variant="outline-alt"
              onClick={() => setReservationConfirmOpen(false)}
              style={{ display: 'block', margin: '0 auto', minWidth: '200px' }}
            >
              {t('reservation.detailsCancel')}
            </Button>
          </Box>
        </Modal>
      )}
      {guestPayConfirmOpen && (
        <Modal setModalOpen={setGuestPayConfirmOpen} modalOpen={guestPayConfirmOpen}>
          <div style={{ position: 'relative', textAlign: 'center', padding: '8px 4px 4px' }}>
            <button
              type="button"
              aria-label={t('close')}
              onClick={() => setGuestPayConfirmOpen(false)}
              style={{
                position: 'absolute',
                top: '-4px',
                right: '-4px',
                width: '48px',
                height: '48px',
                border: 'none',
                background: 'transparent',
                color: '#fff',
                fontSize: '40px',
                fontWeight: 300,
                lineHeight: 1,
                cursor: 'pointer',
                padding: 0,
                zIndex: 1,
              }}
            >
              ×
            </button>
            <p
              style={{
                fontSize: '22px',
                margin: '12px 0 24px',
                color: 'rgba(255, 255, 255, 0.9)',
                lineHeight: '1.45',
                padding: '0 40px',
                fontWeight: 500,
              }}
            >
              {t('guestPay.title')}
            </p>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px', alignItems: 'center', width: '100%' }}>
              <Button
                onClick={handleGuestPayYes}
                style={{
                  ...START_PAGE_ACTION_BUTTON_STYLE,
                  display: 'flex',
                  width: '100%',
                  maxWidth: '100%',
                  margin: 0,
                }}
              >
                <span className="mainBtnText">{t('guestPay.yes')}</span>
              </Button>
              <Button
                variant="outline-alt"
                onClick={handleGuestPayInstallApp}
                style={{
                  ...START_PAGE_ACTION_BUTTON_STYLE,
                  display: 'flex',
                  width: '100%',
                  maxWidth: '100%',
                  margin: 0,
                }}
              >
                <span style={{ fontSize: '22px', letterSpacing: '1px' }}>{t('installApp')}</span>
              </Button>
            </Box>
          </div>
        </Modal>
      )}
      {reservationErrorOpen && (
        <Modal setModalOpen={setReservationErrorOpen} modalOpen={reservationErrorOpen}>
          <h1 className="delayedStartWarning">{t('error')}</h1>
          <p style={{ fontSize: '18px', marginBottom: '24px', color: '#fff9', lineHeight: '1.5' }}>
            {reservationErrorMessage}
          </p>
          <Button
            onClick={() => setReservationErrorOpen(false)}
            className="mainBtn buttonForOfflineStation"
            style={{ display: 'block', margin: '0 auto' }}
          >
            <span className="mainBtnText">OK</span>
          </Button>
        </Modal>
      )}
      {nativeAppFreeChargeOpen && (
        <Modal setModalOpen={setNativeAppFreeChargeOpen} modalOpen={nativeAppFreeChargeOpen}>
          <h1 className="delayedStartWarning">{t('nativeAppFreeChargeError.title')}</h1>
          <p style={{ fontSize: '18px', marginBottom: '24px', color: '#fff9', lineHeight: '1.5' }}>
            {t('nativeAppFreeChargeError.message')}
          </p>
          <Button
            onClick={() => setNativeAppFreeChargeOpen(false)}
            className="mainBtn buttonForOfflineStation"
            style={{ display: 'block', margin: '0 auto' }}
          >
            <span className="mainBtnText">OK</span>
          </Button>
        </Modal>
      )}
      <DriverTermsConfirmModal
        open={termsConfirmOpen}
        onClose={closeTermsConfirmModal}
        onAgree={handleTermsModalAgree}
      />
      <DelayedStartModal
        stationNumber={stationNumber}
        openPaymentLink={openPaymentLink}
        setError={setError}
        kwt={kwt}
        openFrom={openFrom}
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        autoStart={autoStart}
      />
      <StationMediaCarousel
        stationNumber={stationNumber}
        protocolType={station?.protocolType}
        webcamUrl={station?.webcamUrl}
      />
      {canShowRestartStation({ station, stationNumber, historyData, isHistoryReady }) ? (
        <Box className="start-page-footer-actions" sx={{ margin: '20px auto 0' }}>
          <RestartStationButton
            station={station}
            stationNumber={stationNumber}
            historyData={historyData}
            isHistoryReady={isHistoryReady}
          />
        </Box>
      ) : null}
      <StationPublicReportsSection
        stationNumbers={reportStationNumbers}
        reloadToken={reportsReload}
        onFeedback={() => {
          ReactGA.event({
            category: 'feedback',
            action: 'open leave feedback',
          });
          setFeedbackModalOpen(true);
        }}
        onService={() => setServiceRequestModalOpen(true)}
      />
      {renderEndShareButton()}
      <style>{`
        @keyframes fade-animation {
          0% {
            opacity: 0.3;
          }
          50% {
            opacity: 1;
          }
          100% {
            opacity: 0.3;
          }
        }
      `}</style>
    </div>
  );
}
